<template>
  <div class="bbs-channel">
    <van-nav-bar
    v-if="source==1&&pageLength>1"
    :title="channel.alias"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-nav-bar
    v-if="source==1&&pageLength==1"
    :title="channel.alias"
    :fixed="true"
    @click-left="onClickLeft">
    <template #left>
      <van-icon name="wap-home-o" size="18" />
    </template>
  </van-nav-bar>
    <div class="top" :style="{'margin-top':source==1?'50px':'0'}">
      <van-row v-if="channel">
        <van-col span="6">
          <img :src="channel.logo_url" :alt="channel.name" />
        </van-col>
        <van-col span="18" class="intro">
          <h2>{{ channel.alias }}</h2>
          <p class="ellipsis-2">{{ channel.introduce }}</p>
          <!-- <span>{{ channel.fans_num }} 人关注</span> -->
        </van-col>
        <!-- <van-col span="6" class="bintright">
          <van-button plain round>+关注</van-button>
        </van-col> -->
      </van-row>
    </div>
    <div class="content">
      <van-tabs v-if="channel && channel.tags" color="#F6AB00" title-active-color="#F6AB00" v-model="params.tid" @click="getTid">
        <van-tab title="帖子" name=""></van-tab>
        <van-tab v-for="t in channel.tags" :key="'c_tag_' + t.id" :title="t.name" :name="t.id"></van-tab>
      </van-tabs>
      <div class="cenus">
        帖子 {{ total }}
      </div>
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="this.img.loading" />
        <span>正在刷新</span>
      </div>
      <div class="list-box" v-for="(item, index) in list" :key="'list_' + item.id">
        <van-row type="flex" justify="space-between" v-if="item.user">
          <van-col span="4">
            <img class="listhand" :src="item.user.headimg_url ? item.user.headimg_url : img.avatar">
          </van-col>
          <van-col span="16">
            <div class="membername">
              {{item.user.user_name}}
            </div>
            <div class="sourtime">
              {{item.time_format}}  浏览 {{item.show_num}}
            </div>
          </van-col>
          <van-col class="bintright" span="4">
            <!-- <van-button plain round>+关注</van-button> -->
          </van-col>
        </van-row>
        <div class="listitle ellipsis-2" @click="BbsShow(item.id,item.url)">
          {{item.title}}
        </div>
        <div class="f-14 ellipsis-2" @click="BbsShow(item.id,item.url)"><span class="c-blue" v-if="item.tags.length>0">#{{item.tags[0].name}}#</span>
          {{item.content}}
        </div>
        <div class="text-r c-blue f-14" @click="BbsShow(item.id,item.url)">
          查看全部
        </div>
        <div class="pic-box" v-if="item.image.length<3&&item.image.length>0" @click="BbsShow(item.id,item.url)">
          <img class="pic_thumb" v-lazy="item.image[0]">
        </div>
        <div class="pic" v-if="item.image.length==3" @click="BbsShow(item.id,item.url)">

          <van-row gutter="5">
            <van-col span="16">
              <img v-if="item.image && item.image[0]" v-lazy="item.image[0]" />
            </van-col>
            <van-col span="8">
              <img v-if="item.image && item.image[1]" v-lazy="item.image[1]" class="right one" />
              <img v-if="item.image && item.image[2]" v-lazy="item.image[2]" class="right" />
            </van-col>
          </van-row>
        </div>
        <van-grid :border="false" :column-num="3" v-if="item.image.length>3">
          <van-grid-item v-for="(itemd, index) in item.image" :key="'img_' + index" @click="BbsShow(item.id,item.url)">
            <img class="nine-pic" v-lazy="itemd" />
          </van-grid-item>
        </van-grid>
        <van-row type="flex" justify="space-between">
          <van-col span="14">
            <van-tag v-for="t in item.tags" :key="'tag_' + t.id + '_id_' + item.id" color="#F6AB00" round>{{ t.name }}</van-tag>
          </van-col>
          <van-col class="bintright" span="10">
            <span class="">
              <img class="binpic" :src="img.comment">
              <span class="sourtime">{{item.comment_num}}</span>
            </span>
            <span class="binbox">
              <img class="binpic" @click="setPraise(index)" :src="item.is_praise ? img.parise_have : img.parise">
              <span class="sourtime">{{item.praise_num}}</span>
            </span>
          </van-col>
        </van-row>
        <div class="comments" v-if="item.comments.length > 0">
          <van-row gutter="15" v-for="comment in item.comments" :key="'commment_' + comment.id">
            <van-col span="3">
              <img class="avatar" :src="comment.user && comment.user.headimg_url ? comment.user.headimg_url : img.avatar" />
            </van-col>
            <van-col span="21">
              <h3>{{ comment.user.user_name }}<span>{{ comment.create_time }}</span></h3>
              <p v-if="comment.content">{{ comment.content }}</p>
              <van-grid :border="false" :column-num="3" v-if="comment.image.length > 0">
                <van-grid-item v-for="(itemd, index) in comment.image" :key="'img_' + index">
                  <img class="nine-pic" v-lazy="itemd" />
                </van-grid-item>
              </van-grid>
            </van-col>
          </van-row>
          <div class="more">
            <router-link :to="{name: 'BbsShow', params: {id: item.id}}">查看全部消息</router-link>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</div> 
</template>
<script>
  import bbs from '../../../api/bbs';
  import { mapState } from 'vuex';
  import {Grid, GridItem, List, Row, Col, Tab, Tabs, Tag, Button,NavBar,Icon} from "vant";

  export default {
    data () {
      return {
        params: {
          cid: 0,
          tid: 0,
          page: 1,
          size: 4,
          user_id: 0,
          sort: 0
        },
        total: 0,
        channel: null,
        list: [],
        loading: false,
        finished: false,
        pageLength:1,
        img: {
          avatar: require('../../../assets/img/default.jpg'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          comment: require('../../../assets/img/comment.png'),
          loading: require('../../../assets/img/loading.gif')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    watch: {
      '$route'() {
        if(this.$route.params.id != this.params.cid) {
          this.params.cid = this.$route.params.id
          this.getChannel()
        }
      }
    },
    created () {
       this.pageLength=window.history.length
      this.getChannel()
    },
    activated () {
      if(this.source == 3||this.source == 7) {
        this.$appService.isShowReturn({state: true})
      }
      this.$store.commit('param/show', false)
    },
    
    methods: {
      BbsShow(id,url){
        if(url){
          var strs = new Array(); //定义数组 
          strs = url.split("https://h5.motortime.com/lexus/");
          var strsurl = strs[1]
          var strslist = []
          strslist = strsurl.split("/");
          if (strslist[1] && strslist[0] == "article") {
            this.$router.push({name:'ContentPostShow',params:{id:strslist[1]}});
          }
        }else{
          this.$router.push({name:'BbsShow',params:{id:id}});
        }
      },
      setPraise (index) {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

        if(this.user) {
          let type = this.list[index].is_praise ? 2 : 1;
          bbs.setPraise({id: this.list[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.list[index].is_praise = 1
                this.list[index].praise_num += 1
                this.$toast.success('点赞成功')
              } else {
                this.list[index].is_praise = 0
                this.list[index].praise_num -= 1
                this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      getTid() {
        this.params.page = 1;
        this.list = [];
        this.onLoad();
      },
      getChannel() {
        let id = this.$route.params.id
        this.params.cid = id
        bbs.getChannelInfo(id).then(res => {
          if(res.data.state == 1) {
            this.channel = res.data.data
            this.$util.title(res.data.data.alias)
            var apppar={
                title:res.data.data.alias
              }
              this.$appService.changeTitle(apppar)
          }
        })
      },
      onClickLeft(){
        if(this.pageLength==1){
          this.$router.push({name:'Home'});
        }else{
          this.$router.go(-1)
        }
      },
      onLoad() {
        this.params.user_id = this.user ? this.user.id : 0
        // 异步更新数据
        setTimeout(() => {
          bbs.getList(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data.data)
            this.params.page += 1
            this.total = res.data.data.total
            this.loading = false

            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      }
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Tag.name]: Tag,
      [Button.name]: Button,
      [NavBar.name]:NavBar,
    [Icon.name]:Icon,
    }
  };
</script> 

<style lang="scss">
.bbs-channel {
  background-color: #FFF;
  // .van-nav-bar__left {
  //  left: 10px;
  // }
  .top {
    padding: 20px 10px 10px 10px;

    img {
      width: 72px;
      height: 72px;
      display: block;
      object-fit: cover;
    }
    .intro {
      font-size: 12px;

      h2 {
        font-size: 15px;
        margin: 0;
      }
      p {
        color: #9A9A9A;
        line-height: 24px;
        margin: 5px 0;
      }
      span {
        color: #9A9A9A;
      }
    }
    .bintright{
      text-align:right;

      .van-button--default {
        color: #F6AB00;
        border: 1px solid #F6AB00;
        width: 60px;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        padding: 0;
      }
    }
  }
  .content {

    .cenus {
      padding: 0 10px;
      background-color: #F0F0F0;
      color: #9A9A9A;
      font-size: 12px;
      line-height: 40px;
    }
    .van-hairline--top-bottom::after {
      border-width: 0 0 1px 0;
    }
    .van-tab {
      color: #3A3A3A;

      span {
        font-size: 13px;
      }
    }
    .list-box {
      padding: 15px 10px;
      border-bottom: 1px solid #EAEAEA;

      .listitle{
        font-size: 16px;
        font-weight:bold;
        line-height: 32px;
        letter-spacing: 1.4px;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
      }
      .bintright {
        text-align:right;
        .binbox{
          margin-left:20px;
        }
        .binpic{
          width:15px;
          height:14px;
          margin-right:8px;
          vertical-align: middle;
        }
        .van-button--default {
          color: #F6AB00;
          border: 1px solid #F6AB00;
          width: 60px;
          height: 25px;
          line-height: 25px;
          font-size: 12px;
          padding: 0;
        }
      }
      .pic-box {
        padding: 10px 0;
        .pic_thumb {
          border-radius: 5px;
          width: 100%;
          height: 225px;
          object-fit: cover;
          display: block;
        }
      }
      .pic {
        img {
          width: 100%;
          height: 205px;
          object-fit: cover;
          display: block;
          border-radius: 3px;

          &.right {
            height: 100px;
          }
          &.one {
            margin-bottom: 5px;
          }
        }
      }
      .nine-pic {
        width: 100%;
        height: 100px;
        border-radius: 3px;
        object-fit: cover;
        display: block;
      }
      .listhand{
        width:45px;
        height:45px;
        border-radius:30px;
      }
      .membername{
        font-size: 15px;
        font-weight: bold;
      }
      .van-tag{
        padding: 0 5px;
      }
      .quespic{
        width: 22px;
        height: 22px;
      }
      .van-grid-item__content{
        padding: 2.5px;
      }
      .comments {
        border-top: 1px solid #EAEAEA;
        background: #FFF url(../../../assets/img/comment.png) no-repeat top left;
        background-size: 15px auto;
        background-position: 10px 18px;
        padding: 10px 0 0 40px;
        box-sizing: border-box;
        margin-top: 10px;

        .van-row {
          padding-bottom: 10px;
        }
        .avatar {
          width: 30px;
          height: 30px;
          object-fit: cover;
          border-radius: 15px;
        }
        h3 {
          font-size: 15px;
          color: #33A1FF;
          font-weight: normal;
          margin: 0;

          span {
            color: #9A9A9A;
            font-size: 13px;
            float: right;
          }
        }
        p {
          font-size: 15px;
          margin: 5px 0;
        }
        .nine-pic {
          height: 71px;
        }
        .more {
          padding-left: 120px;

          a{
            color: #33A1FF;
            font-size: 12px;
          }
        }
      }

    }
  }
}
</style>
